// Helpers
import { to } from '../../../lib/helpers';
import {
  checkRequestFailure,
  handleRequestFailure,
  ERRORS_MAP,
} from '../../../lib/validation';
import { gaActions } from '../../gaActionTypes';

// Requests
import { userUpdateAddressRequest } from '../../../backend/userRequests';

// Actions
import { openModal } from '../../../reducers/modal/modalActions';

// Consts
export const USER_UPDATE_ADDRESS_SUCCESS_RECEIVED = `[USER] ${gaActions.submit} Update Address Success`;

export const updateAddress = ({
  values: { state, ...values },
  props: { setToggle },
  formikActions,
}) => async dispatch => {
  const data = { ...values, state: state.value };

  const [{ response, body }] = await to(
    dispatch(userUpdateAddressRequest(data))
  );

  if (body.status === 'WARNING' || 'CONTINUE') {
    data.versionId = body.data.versionId;
  }

  if (checkRequestFailure({ response, body }))
    return handleRequestFailure(body, formikActions, ERRORS_MAP.ADDRESS);

  if (
    ['ADDRESS_TWO_INVALID', 'ADDRESS_NOT_VERIFIED', 'INVALID_ADDRESS'].includes(
      body.message
    )
  ) {
    body.status = 'SUCCESS';
    body.data = data;
  }

  if (body.status === 'WARNING') {
    formikActions.setSubmitting(false);

    switch (body.message) {
      case 'ADDRESS_TWO_MISSING':
        return dispatch(
          openModal('AddressTwoMissingModal/AccountPage', {
            enteredAddress: data,
            addressOptions: [body.data],
          })
        );
    }
  }

  if (body.status === 'CONTINUE') {
    return dispatch(
      openModal('VerifyAddressModal/AccountPage', {
        enteredAddress: data,
        addressOptions: [body.data],
      })
    );
  }

  setToggle();

  if (body.status === 'SUCCESS') {
    return dispatch({
      type: USER_UPDATE_ADDRESS_SUCCESS_RECEIVED,
      payload: body.data,
    });
  }
};
